import barba from "@barba/core";

const animationEnd = (el) => {
    return new Promise((resolve) => {
        el.addEventListener("animationend", resolve, { once: true });
    });
};

const leaveAnimation = async (data) => {
    const pageTransition = document.querySelector(".page-transition");
    if (
        data.trigger instanceof HTMLElement &&
        data.trigger.dataset.pageTransitionColor
    ) {
        pageTransition.style.backgroundColor =
            data.trigger.dataset.pageTransitionColor;
    }
    const pageWrapper = document.querySelector(".page-wrapper");
    pageTransition.style.transform = `translate3d(${window.cursorPosition.x}px, ${window.cursorPosition.y}px, 0)`;
    pageTransition.classList.remove("page-transition--open");
    pageTransition.classList.remove("page-transition--close");
    pageTransition.classList.add("page-transition--open");
    await animationEnd(pageTransition);
    window.closeOverlay(false);
    pageWrapper.classList.add("no-transition");
};

const enterAnimation = (data) => {
    const pageTransition = document.querySelector(".page-transition");
    pageTransition.style.backgroundColor = "";
    const pageWrapper = document.querySelector(".page-wrapper");
    pageTransition.classList.add("page-transition--close");
    animationEnd(pageTransition).then(() => {
        pageTransition.classList.remove("page-transition--open");
        pageTransition.classList.remove("page-transition--close");
    });
    setTimeout(() => {
        pageWrapper.classList.remove("no-transition");
    }, 10);
};

barba.init({
    debug: false,
    logLevel: "debug",
    preventRunning: true,
    timeout: 5000,
    prevent: ({ el, href }) => {
        const url = new URL(href);
        if (
            url.pathname.startsWith("/wp-admin") ||
            url.pathname.startsWith("/wp-login") ||
            el.classList.contains("js-no-transition")
        ) {
            return true;
        }
    },
    transitions: [
        {
            name: "default-transition",
            leave: leaveAnimation,
            enter: enterAnimation,
        },
    ],
});

barba.hooks.beforeEnter((data) => {
    // Parse virtual next DOM to extract additional data
    const virtualDomNext = document.createElement("html");
    virtualDomNext.innerHTML = data.next.html;

    // Copy important head tags
    const tags = virtualDomNext.querySelectorAll("head > meta, head > link");
    tags.forEach((tag) => {
        if (
            tag.tagName === "META" &&
            (tag.getAttribute("name") || tag.getAttribute("property"))
        ) {
            const oldTag = tag.getAttribute("name")
                ? document.querySelector(
                    `head > meta[name="${tag.getAttribute("name")}"]`
                )
                : document.querySelector(
                    `head > meta[property="${tag.getAttribute(
                        "property"
                    )}"]`
                );
            if (oldTag) {
                oldTag.outerHTML = tag.outerHTML;
            } else {
                document.head.appendChild(tag);
            }
        }
        if (tag.tagName === "LINK" && tag.getAttribute("rel") === "canonical") {
            const oldTag = document.querySelector(
                `head > link[rel="${tag.getAttribute("rel")}"]`
            );
            if (oldTag) {
                oldTag.outerHTML = tag.outerHTML;
            } else {
                document.head.appendChild(tag);
            }
        }
    });

    // Replace body classes (keep dark mode)
    const isDarkmode = document.body.classList.contains("darkmode");
    if (isDarkmode) {
        virtualDomNext.querySelector("body").classList.add("darkmode");
    } else {
        virtualDomNext.querySelector("body").classList.remove("darkmode");
    }
    document.body.classList.value =
        virtualDomNext.querySelector("body").classList.value;

    // Replace accent-custom-styles if present
    const accentCustomStyles = document.querySelector("#accent-custom-styles");
    const accentCustomStylesNext = virtualDomNext.querySelector(
        "#accent-custom-styles"
    );
    if (accentCustomStylesNext) {
        if (accentCustomStyles) {
            accentCustomStyles.outerHTML = accentCustomStylesNext.outerHTML;
        } else {
            document.head.appendChild(accentCustomStylesNext);
        }
    }

    // Replace adminbar if present
    const adminbar = document.querySelector("#wpadminbar");
    const nextAdminbar = virtualDomNext.querySelector("#wpadminbar");
    if (adminbar && nextAdminbar) {
        adminbar.outerHTML = nextAdminbar.outerHTML;
        // check if customizer is supported (https://wordpress.stackexchange.com/questions/256009/wp-customize-support-script-do-i-need-it)
        document.body.classList.add(
            window.postMessage ? "customize-support" : "no-customize-support"
        );
        document.body.classList.remove(
            window.postMessage ? "no-customize-support" : "customize-support"
        );
    }

    // Run additional scripts
    document
        .querySelectorAll("script[data-loaded-barba]")
        .forEach((oldScript) => {
            oldScript.remove();
        });
    const scripts = data.next.container.querySelectorAll("script");
    scripts.forEach((script) => {
        if (script.innerHTML) {
            try {
                eval.apply(window, [script.innerHTML]);
            } catch (e) {
                console.error(e);
            }
        } else {
            const scriptClone = document.createElement("script");
            scriptClone.src = script.src;
            scriptClone.dataset.loadedBarba = true;
            document.head.appendChild(scriptClone);
        }
    });

    // Copy style tags
    document
        .querySelectorAll("style[data-loaded-barba]")
        .forEach((oldStyle) => {
            oldStyle.remove();
        });
    const styles = virtualDomNext.querySelectorAll("style");
    styles.forEach((style) => {
        const cloneStyle = style.cloneNode(true);
        cloneStyle.dataset.loadedBarba = true;
        document.body.appendChild(cloneStyle);
    });

    // start autoplay videos
    document.querySelectorAll("video[autoplay]").forEach((video) => {
        let isPlaying = video.currentTime > 0 && !video.paused && !video.ended && video.readyState > video.HAVE_CURRENT_DATA;

        if (!isPlaying) {
            video.play();
        }
    });

    // initialize form multiuploads
    if (window.gfMultiFileUploader) {
        data.next.container.querySelectorAll('.gform_fileupload_multifile').forEach((el) => {
            window.gfMultiFileUploader.setup(el);
        });
    }

    // Scroll to top or element
    const scrollTo = window.location.hash;
    const element = document.getElementById(scrollTo.substring(1));
    if (scrollTo && element) {
        element.scrollIntoView();
    } else {
        window.scrollTo(0, 0);
    }
});
